import type { FC, PropsWithChildren } from 'react'

import Grid, { type GridProps } from '@mui/material/Grid'

type FilterGridItemProps = GridProps &
  PropsWithChildren<{ minColumns?: 'double' | 'full' }>

/** This component is just a small abstraction layer over the actual MUI
 * component. It is designed to be overridable by everything that the MUI
 * `<Grid item />` normally takes as props, but has some defaults baked into it.
 * The only non-overridable prop is that this is an `item`. That can not be
 * changed. */
const FilterGridItem: FC<FilterGridItemProps> = ({
  minColumns,
  children,
  ...rest
}) => {
  if (minColumns === 'full') {
    return (
      <Grid size={{ xs: 12 }} {...rest}>
        {children}
      </Grid>
    )
  }

  if (minColumns === 'double') {
    return (
      <Grid size={{ xs: 12, md: 8, lg: 6, xl: 4 }} {...rest}>
        {children}
      </Grid>
    )
  }

  return (
    <Grid size={{ xs: 6, md: 4, lg: 3, xl: 2 }} {...rest}>
      {children}
    </Grid>
  )
}

export default FilterGridItem
